<template>
  <v-container>
    <v-row>
      <v-col cols="12" v-for="(reactivo, index) in reactivos" :key="reactivo.CatReactivo.id">
        <v-row align="center">
          <v-col cols="1">
            {{ index + 1 }}
          </v-col>
          <v-col cols="8">
            <div class="text-subtitle-2">
              {{ reactivo.CatReactivo.title }}
            </div>
          </v-col>
          <v-col>
            <v-select
              class="ui-form-field"
              label="Frecuencia de medición"
              v-model="evaluacion.reactivos[index].idFrecuencia"
              rounded
              filled
              dense
              :items="frecuencia"
              item-value="id"
              item-text="title"
              item-color="secondary"
              color="secondary"
              background-color="transparent"
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="my-2"></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    evaluacion: {
      type: Object,
      required: true,
    },

    reactivos: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters('frecuenciaRespetoPrincipio', {
      frecuencia: 'getFrecuenciaRespetoPrincipio',
    }),
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

.text-subtitle-2 {
  color: #e0e0e0 !important;
}
</style>
